export default __webpack_public_path__ + "static/media/plus-viewer.98ed59a7.svg";